// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n[data-v-6416b188] .el-dialog__body {\n  padding: 20px 24px 0 24px !important;\n}\n", ""]);
// Exports
module.exports = exports;
